module.exports = __webpack_public_path__ + "static/img/share-banner.7e68b3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share-banner.png
// module id = ONxW
// module chunks = 1